<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="flex flex-wrap items-center">
      <flat-pickr v-model="date_range" :config="config" style="width:190px" />
      <vs-select v-if="user_info.role == 'DEVELOPER'" v-model="role">
        <vs-select-item value="all" text="All" />
        <vs-select-item value="other" text="Non-Developer" />
        <vs-select-item value="developer" text="Developer" />
      </vs-select>
      <vs-button :disabled="false || !permissions_list" class="ml-1" color="primary" type="filled" icon="search" @click="loan_report"></vs-button>
      
    </div>

    <vx-card>
      <vs-button :disabled="report_list.length == 0" class="ml-1 mb-4" @click="download_pdf">Download</vs-button>

      <vs-table :data="report_list" v-show="false">
        <template slot="thead">
          <vs-th>No</vs-th>
          <vs-th>Date</vs-th>
          <vs-th>Account</vs-th>
          <vs-th>Settlement</vs-th>
          <vs-th>Discount</vs-th>
          <vs-th>Interest</vs-th>
          <vs-th>Debit</vs-th>
          <vs-th>Credit</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].index">
              {{ data[indextr].index }}
            </vs-td>

            <vs-td :data="data[indextr].ldate">
              {{ data[indextr].ldate }}
            </vs-td>

            <vs-td :data="data[indextr].account">
              {{ data[indextr].account }}
            </vs-td>

            <vs-td :data="data[indextr].settlement">
              {{ formatPrice(data[indextr].settlement) }}
            </vs-td>

            <vs-td :data="data[indextr].discount">
              {{ formatPrice(data[indextr].discount) }}
            </vs-td>

            <vs-td :data="data[indextr].interest">
              {{ formatPrice(data[indextr].interest) }}
            </vs-td>

            <vs-td :data="data[indextr].debit">
              {{ formatPrice(data[indextr].debit) }}
            </vs-td>

            <vs-td :data="data[indextr].credit">
              {{ formatPrice(data[indextr].credit) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <table id="my-table" width="100%" v-show="true">
        <thead>
          <tr width="100%">
            <th>No</th>
            <th>Date</th>
            <th>Account</th>
            <th>Settlement</th>
            <th>Discount</th>
            <th>Interest</th>
            <th>Debit</th>
            <th>Credit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in report_list">
            <td>{{ item.index }}</td>
            <td>{{ item.ldate }}</td>
            <td><router-link :to="`/loan_detail/${item.loan_uuid}`" class="text-inherit underline">{{ item.account }}</router-link></td>
            <!-- <td>{{ item.account }}</td> -->
            <td>{{ formatPrice(item.settlement) }}</td>
            <td>{{ formatPrice(item.discount) }}</td>
            <td>{{ formatPrice(item.interest) }}</td>
            <td>{{ formatPrice(item.debit) }}</td>
            <td>{{ formatPrice(item.credit) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4"><b>Total</b></td>
            <td><b>{{ computed_discount }}</b></td>
            <td><b>{{ computed_interest }}</b></td>
            <td><b>{{ computed_debit }}</b></td>
            <td><b>{{ computed_credit }}</b></td>
          </tr>
        </tfoot>
      </table>
     </vx-card>


    <vs-prompt
      color="danger"
      title="Incomplete date range"
      close="activePrompt2 = false"
      :buttons-hidden="true"
      :active.sync="activePrompt2">
       <div class="con-exemple-prompt">
        Please select date of range. <br><b>{{date_range}} to ?</b>
       </div>
     </vs-prompt>
    
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import jsPDF from 'jspdf' 
import autoTable from 'jspdf-autotable'
import {sample} from './sample.js'
import moment from 'moment'
// import DataViewSidebar from './sidebar.vue'
// // Store Module
// import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  name: 'Report',
  components: {
    // DataViewSidebar
    flatPickr
  },
  data () {
    return {
      // Get more form https://flatpickr.js.org/options/
      config: {
          wrap: false, // set wrap to true only when using 'input-group'
          dateFormat: 'Y-m-d',
          mode: "range",
      },
      sample: sample,
      // date_range: '2021-12-01 to 2022-04-10',
      date_range: '',
      report_list: [],
      activePrompt2: false,
      role: 'all'
    }
  },
  computed: {
    user_info(){
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    generateByDateRange(){
      let dates = this.date_range.split(' to ')
      if(dates.length > 0){
        return dates[0]+'-'+dates[1]
      }
      else{
        return 'empty'
      }
    },
    permissions () {
      if(this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions){
        return this.$store.state.AppActiveUser.permissions;
      }
      else{
        return []
      }
    },
    permissions_list(){
      if(this.permissions.includes('*') || this.permissions.includes('042')){
        return true
      }
      else{
        return false
      }
    },
    computed_discount(){
      let total = 0
      this.report_list.forEach(function(item){
        total += parseFloat(item.discount)
      })
      return total.toFixed(2)
    },
    computed_interest(){
      let total = 0
      this.report_list.forEach(function(item){
        total += parseFloat(item.interest)
      })
      return total.toFixed(2)
    },
    computed_debit(){
      let total = 0
      this.report_list.forEach(function(item){
        total += parseFloat(item.debit)
      })
      return total.toFixed(2)
    },
    computed_credit(){
      let total = 0
      this.report_list.forEach(function(item){
        total += parseFloat(item.credit)
      })
      return total.toFixed(2)
    },
  },
  methods: {
    formatPrice(target){
      return parseFloat(target).toFixed(2)
    },
    download_pdf() {
      let doc =new jsPDF()
      console.log(doc)
      // autoTable(doc, { html: '.vs-table' })
      // doc.save(`${this.generateByDateRange}.pdf`)

      autoTable(doc, {html: '#my-table', theme: 'striped'})
      doc.save(`${this.generateByDateRange}.pdf`)
    },
    loan_report(){
      let self = this
      let dates = this.date_range.split(' to ')
      console.log(dates)

      if(dates.length == 2){
        this.$vs.loading()
        self.report_list = []
        let baseURI = 'reports'
        let formData = new FormData();
        formData.append('start_date', dates[0])
        formData.append('end_date', dates[1])

        if(this.user_info.role == 'DEVELOPER'){
          formData.append('role', this.role)
          baseURI = 'reports/developer'
        }

        this.$http.post(baseURI,formData)
        .then((result) => {
          if(result.data.status == 'success'){
            console.log(result.data.data, result.data.data.length)
            if(result.data.data.length > 0){
              result.data.data.forEach(function(item,index){
                self.report_list.push({
                  index: (index+1).toString(),
                  ldate: item.ldate,
                  account: item.account,
                  admin_name: item.admin_name,
                  settlement: item.credit !== '' ? item.settlement || '0' : '0',
                  discount: item.discount || '0',
                  interest: item.interest || '0',
                  debit: item.debit || '0',
                  credit: item.credit || '0',
                  loan_uuid: item.loan_uuid
                })
              })
              self.$vs.loading.close()
            }
            else{
              self.$vs.loading.close()
              self.$vs.notify({
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'primary',
                title: `No record found in from ${this.date_range}`
              })
              self.report_list = self.sample
            }
          }
        })
        .catch((err) => {
          if(err.logout){
            this.$vs.loading.close()
            this.$vs.notify({
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              title: err.msg
            })
            sessionStorage.removeItem('accessToken')
            sessionStorage.removeItem('user')
            this.$router.push('/pages/login').catch(() => {})
          }
        })
      }
      else{
        // this.$vs.dialog({
        //   color:'primary',
        //   title: 'Incomplete date range',
        //   text: 'Please select date of range',
        //   ButtonsHidden: true
        // })

        this.activePrompt2 = true

        // this.$vs.notify({
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'danger',
        //   title: 'Incomplete date range'
        // })
      }
    }
  },
  created () {
    this.date_range = moment().startOf('year').format('YYYY-MM-DD') + " to "+moment().format("YYYY-MM-DD")
  },
  mounted () {

  }
}
</script>

<style lang="scss">
#my-table{
  border-collapse: collapse;
  width: 100%;
  th,td{
    border: 1px solid #ddd;
    padding: 8px;
  }

  thead{
    font-weight:bold;
  }
}
</style>
